// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DetailsFilledSvg from "@fishx/icons-svg/es/asn/DetailsFilled";
import FishxIcon from '../components/FishxIcon';

var DetailsFilled = function DetailsFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DetailsFilledSvg
  }));
};

DetailsFilled.displayName = 'DetailsFilled';
export default React.forwardRef(DetailsFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DetailsFilled.js
// module id = 2412
// module chunks = 0